import React, { useEffect, useState } from "react";
import "../pages/JobDetailPage 1.css";
import { useParams, useNavigate } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";
import { getJobById } from "../services/jobsApi";
import { applyForJob } from "../services/jobsApi";
import { incrementJobView } from "../services/jobsApi";

/* Inline SVG for Share icon */
const ShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M16 6l-4-4-4 4"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12 2v14"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export default function JobDetailPage() {
  const navigate = useNavigate()
  const { id } = useParams(); // get job ID from URL like /job/1
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    async function fetchJob() {
      try {
        const data = await getJobById(id);
        setJob(data);
      } catch (err) {
        console.error("Error fetching job details:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchJob();
  }, [id]);

  useEffect(() => {
    const stored = localStorage.getItem(`applied_job_${id}`);
    setApplied(stored === "true");
  }, [id]);

  // view 
  // view count incremented on 2-1-2026
  useEffect(() => {
  if (job?.id) {
    incrementJobView(job.id);
  }
}, [job]);

  if (loading) return <div className="job-detail-root">Loading...</div>;
  if (!job) return <div className="job-detail-root">Job not found</div>;
   // added on 26-11-2025 to disable apply button if already applied
  const handleApply = async () => {
    try {
      const res = await applyForJob(job.id);
      localStorage.setItem(`applied_job_${job.id}`, "true");
      setApplied(true);
      alert("You have successfully applied!");
    } catch (err) {
      if (err.response?.status === 409) {
        localStorage.setItem(`applied_job_${id}`, "true");
        alert("You already applied for this job");
        setApplied(true);
      } else {
        alert("Failed to apply");
        console.error(err);
      }
    }
  };

  return (
    <div className="detail-job-page-root">
      {/* <button onClick={()=>navigate("/jobs")}  className="detail-page-back" >←</button> */}
      
      <div className="detaill-container">
      {/* ---------- HEADER ---------- */}
      <div className="detail-left">
      <main className="detail-slides-wrapper">
      <header className="detail-job-header">
        <div className="detail-header-left">
          <img
            className="detail-logo"
            src={job.companyLogo || "https://via.placeholder.com/80"}
            alt="Company logo"
          />
          <div className="detail-header-left-text">
            <h1 className="detail-job-title">{job.title}</h1>
            {/* <div className="company-row"> */}
              <span className="detail-companyy-name">{job.company}</span>
              {/* {job.rating && (
                <span className="rating">
                  ★ {job.rating} · {job.reviews || 0} reviews
                </span>
              )} */}
            {/* </div> */}
            <div className="detail-locationn">
              <FiMapPin style={{color:"#1a73e8"}}/> {job.location}</div>
          </div>

          <div className="detail-header-right">
            <button className="detail-share-button" title="Share job">
              <ShareIcon />
              <span className="detail-share-text">Share</span>
            </button>
          </div>
        </div>

        {/* ---------- JOB STATS ---------- */}
        <div className="detail-job-stats">
          <div className="detail-stat">
            <div className="detail-stat-label">Experience</div>
            <div className="detail-stat-value">{job.experience}</div>
          </div>
          <div className="detail-stat">
            <div className="detail-stat-label">Applicants</div>
            <div className="detail-stat-value">{job.applicants || 0}</div>
          </div>
          <div className="detail-stat">
            <div className="detail-stat-label">Salary</div>
            <div className="detail-stat-value">{job.salary}</div>
          </div>
          <div className="detail-stat">
            <div className="detail-stat-label">Posted</div>
            <div className="detail-stat-value">{job.posted}</div>
          </div>
        </div>

        {/* ---------- ACTION BUTTONS ---------- */}
        <div className="detail-stat-actions">
          <button className="detail-btn save">Save</button>
          {/*<button className="btn apply">Apply</button>*/} 
          {/* <button className="detail-btn apply" disabled={applied} onClick={handleApply}>Apply</button> */}
          <button
              className={`detail-btn apply ${applied ? "applied" : ""}`}
              disabled={applied}
              onClick={handleApply}
            >
              {applied ? "Applied" : "Apply"}
            </button>

        </div>
      </header>

      {/* ---------- MAIN SLIDES ---------- */}
      
        {/* --- SLIDE 1: Highlights & Qualifications --- */}
        <section className="detail-slide container">
          <div className="detail-card">
            <h2 className="detaill-card-title">Job Highlights</h2>
            <ul className="detail-bullet-list">
              {job.highlights?.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
          </div>

          <div className="detail-card">
            <h2 className="detaill-card-title">Qualifications</h2>
            <ul className="detail-bullet-list">
              {job.qualifications?.map((q, i) => (
                <li key={i}>{q}</li>
              ))}
            </ul>
          </div>

          <div className="detail-card match-card">
            <div className="detaill-card-title">Job Match Score</div>
            <div className="detail-match-body">
              <div className="detail-match-row">
                {job.match?.earlyApplicant ? (
                  <span className="detail-badge green">Early applicant</span>
                ) : (
                  <span className="detail-badge">—</span>
                )}
              </div>
              <div className="detail-muted">
                <strong>Key skills:</strong>{" "}
                {job.match?.skills?.join(", ") || "N/A"}
              </div>
              <div className="detail-muted">
                <strong>Education:</strong> {job.match?.education || "N/A"}
              </div>
              <div className="detail-muted">
                <strong>Work experience:</strong> {job.match?.min_exp || "N/A"}
              </div>
              <div className="detail-mutedd">
                <strong>Score :</strong> {job.match?.score || "—"}
              </div>
            </div>
          </div>
        </section>

        {/* --- SLIDE 2: Description & Responsibilities --- */}
        <section className="detail-slide container">
          <div className="detail-card full">
            <h2 className="detaill-card-title">Job Description</h2>
            <p className="detail-muted">{job.description}</p>

            <h3 className="detaill-card-title">Roles & Responsibilities</h3>
            <ul className="detail-bullet-list">
              {job.responsibilities?.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>

            <div className="detail-skills-row">
              {job.skills?.map((s, i) => (
                <button key={i} className="detail-skill-btn">
                  {s}
                </button>
              ))}
            </div>

            <div className="detail-mt-18">
              <strong>Vacancy:</strong> {job.openings || "N/A"} <br /> <br/>
              <strong>Employment Type:</strong> {job.employmentType || "N/A"}{" "}
              <br /> <br/>
              <strong>Evaluation:</strong> {job.evaluation || "N/A"} <br />  <br/>
              <strong>Education:</strong> {job.education || "N/A"}
            </div>
          </div>
        </section>

        {/* --- SLIDE 3: About Company --- */}
        <section className="detail-slide container">
          <div className="detail-card full">
            <div className="detail-company-top">
              <div className="detail-company-left">
                <img
                  className="detail-logo-lg"
                  src={job.companyLogo || "https://via.placeholder.com/96"}
                  alt="Company logo"
                />
                <div>
                  <div className="detail-company-large">{job.company}</div>
                  <div className="detail-muted"><FiMapPin style={{color:"#1a73e8",paddingRight:"3px"}}/>{job.companyLocation}</div>
                </div>
              </div>
              <div className="detail-company-right">
                {job.verified && <span className="detail-verify">✔</span>}
              </div>
            </div>

            <h2 className="detaill-card-title">About Company</h2>
            <p className="detail-muted">{job.companyInfo}</p>
          </div>
        </section>
        </main>
        </div>

        {/* --- SLIDE 4: Similar Jobs --- */}
        <div class="detaill-right">
        <section className="detail-slide container">
          <div className="detail-card full">
            <h2 className="detaill-card-title">Similar Jobs</h2>
            <div className="detail-similar-grid">
              {Array.from({ length: 6 }).map((_, i) => (
                <div className="detail-sim-card" key={i}>
                  <img
                    src="https://via.placeholder.com/56"
                    alt="logo"
                    className="detail-sim-logo"
                  />
                  <div className="detail-sim-info">
                    <div className="detail-sim-title">
                      Frontend Developer — Company {i + 1}
                    </div>
                    <div className="detail-muted">
                      Bangalore · {Math.floor(Math.random() * 6) + 1} openings
                    </div>
                  </div>
                  <div className="detail-sim-action">
                    <button className="detail-btn small">View</button>
                  </div>
                </div>
              ))}
            </div>

            <div className="detail-center mt-18">
              <button className="detail-btn applyy">View More Similar Jobs</button>
            </div>
          </div>
        </section>
        </div>
      </div>
    </div>
  );
}
